import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import Lightbox from 'react-image-lightbox';
import '../../../sass/apps/photo_gallery/carousel.scss';
import '../../../sass/apps/photo_gallery/lightbox.scss';
import '../../../sass/apps/photo_gallery/photo_gallery.scss';

class App extends React.Component {
  constructor() {
    super();
    this.state = { photoIndex: 0 };
    this.closeLightbox = this.closeLightbox.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
    this.openCheck = this.openCheck.bind(this);
    this.openVideo = this.openVideo.bind(this);
    this.openSingleImage = this.openSingleImage.bind(this);
    this.getImageCaption = this.getImageCaption.bind(this);
    this.loadYoutubeVideo = this.loadYoutubeVideo.bind(this);
    this.onPlayerReady = this.onPlayerReady.bind(this);
  }

  componentDidMount() {
    const { video } = this.props;
    if (video && video.type === 'youtube') {
      if (!window.YT) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';

        window.onYouTubeIframeAPIReady = this.loadYoutubeVideo;

        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      } else {
        this.loadYoutubeVideo();
      }
    }
    if (video) {
      this.openCheck(0);
    }
  }

  openCheck(event) {
    if (this.props.video && event === 0) {
      return this.openVideo();
    }
    return this.openLightbox(event);
  }

  openVideo() {
    this.setState({
      videoIsOpen: true,
    });
    if (this.player) {
      this.player.playVideo();
    }
  }

  loadYoutubeVideo() {
    const { id } = this.props.video;

    this.player = new window.YT.Player(`player-${id}`, {
      videoId: id,
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: 1,
        controls: 1,
        rel: 0,
      },
      events: {
        onReady: this.onPlayerReady,
      },
    });
  }

  onPlayerReady() {
    this.player.mute();
    this.player.pauseVideo();
  }

  openSingleImage() {
    this.setState({
      isOpen: true,
    });
  }

  openLightbox(event) {
    this.setState({
      photoIndex: this.props.video ? event - 1 : event,
      isOpen: true,
    });
  }

  closeLightbox() {
    this.setState((prevState, props) => ({
      photoIndex: props.video ? prevState.photoIndex + 1 : prevState.photoIndex,
      isOpen: false,
    }));
  }

  gotoPrevious() {
    this.setState((prevState, props) => ({
      photoIndex: prevState.photoIndex
        ? (prevState.photoIndex - 1) % props.photos.length
        : props.photos.length - 1,
    }));
  }

  gotoNext() {
    this.setState((prevState, props) => ({
      photoIndex: (prevState.photoIndex + 1) % props.photos.length,
    }));
  }

  lightboxPrevious(photos) {
    const index = this.state.photoIndex;
    const resolvedIndex = (this.state.photoIndex - 1) % photos.length;
    return index
      ? photos[resolvedIndex].photo
      : photos[photos.length - 1].photo;
  }

  mainImage(photos) {
    const index = this.state.photoIndex;
    return photos[index].photo;
  }

  getImageCaption() {
    const { caption } = this.props.photos[this.state.photoIndex];
    const imageIndex = `${this.state.photoIndex + 1} of ${
      this.props.photos.length
    }`;
    if (caption) {
      return `${imageIndex} - ${caption}`;
    }

    return imageIndex;
  }

  render() {
    const { photos, video } = this.props;
    const { photoIndex } = this.state;
    const carouselPhotos = video
      ? [
          {
            photo: video.thumb,
          },
          ...photos,
        ]
      : photos;
    let gallery;
    if (carouselPhotos.length === 1) {
      gallery = (
        <div className="singleImage">
          <img
            src={photos[0].photo}
            alt={`Main photo: ${photos[0].caption}`}
            onClick={this.openSingleImage}
          />
        </div>
      );
    } else {
      gallery = (
        <Carousel
          showIndicators={false}
          emulateTouch={true}
          showStatus={false}
          infiniteLoop={true}
          onChange={(event) => {
            this.setState({ photoIndex: event, videoIsOpen: video && event == 0 });
            if (this.player) {
              this.player.pauseVideo();
            }
          }}
          selectedItem={photoIndex}
          onClickItem={this.openCheck}
        >
          {carouselPhotos.map((photo, index) => (
            <img
              key={index}
              src={photo.photo}
              alt={`Photo ${index + 1}: ${photo.caption}`}
            />
          ))}
        </Carousel>
      );
    }

    return (
      <div className="photo-gallery--container">
        <div>{gallery}</div>
        {this.state.isOpen && (
          <Lightbox
            mainSrc={this.mainImage(photos)}
            nextSrc={photos[(photoIndex + 1) % photos.length].photo}
            prevSrc={this.lightboxPrevious(photos)}
            onCloseRequest={() => this.closeLightbox()}
            onMovePrevRequest={() => this.gotoPrevious()}
            onMoveNextRequest={() => this.gotoNext()}
            imageTitle={this.getImageCaption()}
          />
        )}
        {video && (
          <div
            className={`video ${this.state.videoIsOpen ? 'video--open' : ''}`}
          >
            {video && video.type == 'youtube' && (
              <div id={`player-${video.id}`}></div>
            )}
            {video && video.type == 'vimeo' && (
              <iframe
                width="640"
                height="100%"
                src={
                  this.state.videoIsOpen
                    ? `${video.player_url}&autoplay=false&muted=0`
                    : ''
                }
                frameBorder="0"
                allowFullScreen="1"
                title="Video"
                className="video__iframe"
                allow="autoplay"
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default App;
